import * as React from "react";
/**
 * BackgroundImageWrapper
 * @param {style} React.CSSProperties for example { backgroundImage: `url("image-link")`)}
 * @param {className} string block className
 */
export class BackgroundImageWrapper extends React.PureComponent {
    render() {
        return (React.createElement("div", { className: `rj-background-img-wrapper ${this.props.className}`, "data-uat": "background-img", style: this.props.style }, this.props.children));
    }
}
//# sourceMappingURL=BackgroundImageWrapper.js.map